import React from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import './PrintButton.css';

const PrintButton = () => {
	const { t } = useTranslation();
    const navigate = useNavigate();

    return <span className='PrintButton' onClick={() => navigate('print')}>
        <Icon icon={faPrint}/>&nbsp;&nbsp;
        <span className='a'>{t('profile.print')}</span>
    </span>
};

export default PrintButton;